<template>
  <div class="container">
    <!-- <img
      class="header"
      :src="covers && covers.length > 1 ? covers[1].imgUrl : ''"
    /> -->
    <img
      class="header"
      :src="
        detailCategory == 'tipoff'
          ? require('@/assets/tipoff.png')
          : require('@/assets/advice.png')
      "
    />
    <div class="content">
      <van-cell-group inset>
        <van-cell>
          <template #title>
            <div class="custom-title">
              <div>{{ detail.nickname }}</div>
              <div>
                {{ dealDate(detail.createtime) }}
              </div>
            </div>
            <div class="custom-content">{{ detail.user_content }}</div>
            <div class="custom_imgs">
              <img
                v-for="(image, index) in detail.images"
                :key="index"
                :src="image"
                @click="imgClick(index)"
              />
            </div>
            <div class="like-btn-container">
              <van-button
                class="like-btn"
                icon="like"
                size="mini"
                style="border: none"
                :type="buttonType"
                @click="contentLike(detail.id, index, 1)"
                @click.stop
                plain
                >{{ detail.like }}</van-button
              >
            </div>
          </template>
        </van-cell>
        <van-cell
          v-for="(item, index) in detail.news"
          :key="index"
          @click="toPlus(item)"
        >
          <template #title>
            <div class="news-tip" v-if="index === 0">
              <span>跟进新闻</span>
            </div>
            <div
              :class="
                item.list_imgs.length === 1 && item.list_type === 0
                  ? 'custom-flex'
                  : ''
              "
            >
              <div class="list-content">
                <span class="white van-multi-ellipsis--l2">
                  {{ item.title }}</span
                >
                <div v-if="item.list_imgs.length == 1 && item.list_type == 0">
                  <van-button
                    size="mini"
                    style="border: none"
                    :type="item.buttonType"
                    @click.stop
                    plain
                  >
                    中山日报 · {{ item.publish_time }}</van-button
                  >
                </div>
              </div>
              <div
                :class="
                  item.list_imgs.length === 1 && item.list_type === 0
                    ? 'list-image'
                    : 'custom-box'
                "
              >
                <van-grid
                  class="custom-img"
                  :border="false"
                  v-for="(image, index) in item.list_imgs"
                  :key="image"
                  direction="horizontal"
                  :column-num="item.list_imgs.length"
                  :gutter="0"
                >
                  <van-grid-item class="content-image">
                    <van-image
                      v-if="item.list_imgs.length === 1 && item.list_type === 1"
                      width="100%"
                      height="100%"
                      radius="6"
                      fit="contain"
                      position="center"
                      :src="image"
                      @click="imgClick(item, index)"
                      @click.stop
                    />
                    <van-image
                      v-else-if="item.list_imgs.length === 2"
                      width="114px"
                      height="114px"
                      radius="6"
                      fit="cover"
                      :src="image"
                      @click="imgClick(index)"
                      @click.stop
                    />
                    <van-image
                      v-else-if="item.list_imgs.length >= 3"
                      width="96px"
                      height="96px"
                      radius="6"
                      fit="cover"
                      :gutter="6"
                      :src="image"
                      @click="imgClick(index)"
                      @click.stop
                    />
                  </van-grid-item>
                  <van-image
                    class="listType"
                    v-if="item.list_imgs.length === 1 && item.list_type === 0"
                    width="108px"
                    height="72px"
                    radius="6"
                    fit="contain"
                    position="center"
                    :src="item.img"
                    @click.stop
                  />
                </van-grid>
              </div>
            </div>
          </template>
          <template #label>
            <div
              class="custom_detail"
              v-if="item.list_imgs.length !== 1 && item.list_type !== 0"
            >
              <div class="detail_left">
                <van-button
                  size="mini"
                  style="border: none"
                  :type="item.buttonType"
                  @click.stop
                  plain
                >
                  中山日报 · {{ item.publish_time }}</van-button
                >
              </div>
            </div>
          </template>
        </van-cell>
      </van-cell-group>
      <van-cell-group inset v-if="detail.replys || detail.comments">
        <div>
          <div
            class="replys-tip"
            v-if="detail.replys.length !== 0 || detail.comments.length !== 0"
          >
            评论
          </div>
          <van-empty v-else class="custom-image" description="暂无评论" />
        </div>
        <van-cell
          v-for="(reply, replyIndex) in detail.replys"
          :key="replyIndex"
        >
          <template #title>
            <div class="content-reply">
              <span>官方回复</span>
              中山+
            </div>
            <div class="list-content">
              {{ reply.official_reply }}
            </div>
          </template>
          <template #label>
            <div class="comment-detail">
              <div class="comment-ldetail">
                {{ dealDate(reply.createtime) }}
              </div>
              <van-button
                icon="like"
                size="mini"
                class="like-btn"
                style="border: none"
                :type="reply.buttonType"
                @click="contentLike(reply.id, replyIndex, 3)"
                @click.stop
                plain
                >{{ reply.like }}</van-button
              >
            </div>
          </template>
        </van-cell>
        <van-cell
          v-for="(comment, commentIndex) in detail.comments"
          :key="commentIndex"
        >
          <template #title>
            <div class="comment-name">{{ comment.nickname }}</div>
            <div class="comment-content">{{ comment.user_comment }}</div>
            <div
              class="comment-reply"
              v-for="(commentReply, index) in comment.replys"
              :key="index"
            >
              <span>中山+：</span>{{ commentReply.official_reply }}
            </div>
          </template>
          <template #label>
            <div class="comment-detail">
              <div class="comment-ldetail">
                {{ dealDate(comment.createtime) }}
              </div>
              <van-button
                icon="like"
                size="mini"
                class="like-btn"
                style="border: none"
                :type="comment.buttonType"
                @click="contentLike(comment.id, commentIndex, 2)"
                @click.stop
                plain
                >{{ comment.like }}</van-button
              >
            </div>
          </template>
        </van-cell>
      </van-cell-group>
    </div>
    <div class="btn-div">
      <van-button
        color="linear-gradient(to right, #f56c42, #feb91f)"
        round
        class="wish-lbtn button glass"
        @click="comment(detail.id)"
        >前往评论
      </van-button>
      <van-button
        color="linear-gradient(to right, #f56c42, #feb91f)"
        round
        class="wish-rbtn button glass"
        to="/"
        >返回首页
      </van-button>
    </div>
  </div>
  <CommentForm v-model:show="showForm" :contentId="selectedContentId" />
</template>

<script>
import useDateDiff from "@/composiables/useDateDiff.js";
import {
  Button,
  Cell,
  CellGroup,
  Grid,
  GridItem,
  Image as VanImage,
  ImagePreview,
  Empty,
} from "vant";
import { useStore } from "vuex";
import { ref, computed } from "vue";
import CommentForm from "@/components/CommentForm.vue";
import { useRoute } from "vue-router";
import { wxshareInit } from "@/plugins/wechatSDK.js";
import "@/plugins/bridge.js";
export default {
  name: "Detail",
  components: {
    [VanImage.name]: VanImage,
    [ImagePreview.Component.name]: ImagePreview.Component,
    [GridItem.name]: GridItem,
    [Grid.name]: Grid,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    CommentForm,
    [Empty.name]: Empty,
  },

  setup() {
    const store = useStore();
    const route = useRoute();

    const params = {
      content_id: route.params.id,
    };
    store.dispatch("contentDetail", params);
    const showForm = ref(false);

    const selectedContentId = ref(0);
    const comment = (id) => {
      selectedContentId.value = id;
      showForm.value = true;
    };

    const buttonType = ref("default");
    const contentLike = (id, index, type) => {
      console.log(type);
      const params = {
        id: id,
        type: type,
      };
      if (type === 1) {
        store.dispatch("contentLike", { params, index, buttonType });
      } else {
        store.dispatch("contentLike", { params, index });
      }
    };

    const like = (id, index) => {
      console.log(id, index);
      const params = {
        id: id,
        type: 2,
      };
      store.dispatch("contentLike", { params, index });
    };

    const dealDate = (dateString) => {
      return useDateDiff(dateString);
    };

    const toPlus = (item) => {
      window.location.href = item.url;
    };

    return {
      detail: computed(() => store.state.detail),
      detailCategory: computed(() => store.state.detailCategory),
      comment,
      like,
      contentLike,
      buttonType,
      showForm,
      selectedContentId,
      dealDate,
      toPlus,
      covers: computed(() => store.state.covers),
    };
  },

  created() {
    // let id = this.$store.state.detail.id;
    console.log(this.$route);
    window.ZsrbApp.call("shareInfo", {
      title: "中山市“文明眼”网上监督平台",
      img: "https://zsrbactivity.zsnews.cn" + require("../assets/zsplus.jpg"),
      desc: "全民齐参与 共创典范城",
      url:
        "https://zsrbactivity.zsnews.cn/vue/civilization/#" + this.$route.path,
    });

    wxshareInit({
      title: "中山市“文明眼”网上监督平台",
      imgUrl:
        "https://zsrbactivity.zsnews.cn" + require("../assets/zsplus.jpg"),
      description: "全民齐参与 共创典范城",
      url:
        "https://zsrbactivity.zsnews.cn/vue/civilization/#" + this.$route.path,
      successMethod: "",
    });
  },
};
</script>

<style lang="scss" scoped>
.container {
  background: #f8f8f8;
  background-size: contain;
  min-height: 100vh;
}
.header {
  height: auto;
  width: 100%;
}
.content {
  padding-bottom: 110px;
  background: #f8f8f8;
  position: relative;
}
.content-group {
  margin: var(--van-cell-label-margin-top) 12px;
}
.van-cell-group--inset {
  margin: 12px 20px;
}
.custom-title {
  font-size: 3.9vw;
  color: #1c1c1c;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 5px;
}
.custom-content {
  font-size: 3.9vw;
  color: #1c1c1c;
  text-align: left;
  margin-top: 15px;
  white-space: pre-wrap;
}
.custom_imgs img {
  width: 100%;
  height: 100%;
  margin-top: 10px;
  max-width: 100vw;
}
.like-btn-container {
  display: flex;
  justify-content: flex-end;
}
.like-btn {
  --van-button-default-color: #aaa5a5;
}
.comment-tip {
  font-size: 3.6vw;
  color: #525252;
  font-weight: bold;
  text-align: left;
  padding: 15px 0 13px 0px;
}
.comment-name {
  font-size: 3.6vw;
  color: #1c1c1c;
  text-align: left;
  margin: 3px 0;
  font-weight: 600;
}
.content-reply {
  color: #aaa5a5;
  font-size: 4vw;
  font-weight: 600;
  text-align: left;
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  span {
    font-size: 3vw;
    width: 64px;
    height: 23px;
    background: #ff8831;
    color: #ffffff;
    border-radius: 12px;
    margin-right: 6px;
    text-align: center;
  }
}
.comment-reply {
  // width: 300px;
  padding: 10px;
  background: #f8f8f8;
  color: #777777;
  margin: 0 auto;
  text-align: left;
  margin-bottom: 12px;
  span {
    color: #6485c8;
    font-weight: bold;
  }
}
.comment-content {
  font-size: 3.8vw;
  color: #1c1c1c;
  text-align: left;
  margin: 5px 0 10px 0;
}
.comment-detail {
  display: flex;
  justify-content: space-between;
}
.comment-ldetail {
  font-size: 3.2vw;
  color: #cfcfcf;
}
.comment-rdetail {
  font-size: 4vw;
  color: #aaa5a5;
}
.btn-div {
  position: fixed;
  bottom: 35px;
  z-index: 100;
  margin: 0px auto;
  right: 0px;
  left: 0px;
}
.wish-lbtn {
  padding: 15px 30px;
  text-align: center;
  margin-right: 15px;
}
.wish-rbtn {
  padding: 15px 30px;
  text-align: center;
  margin-left: 15px;
}
.custom_detail {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  .comment-news {
    font-size: 3.6vw;
    color: #303133;
    text-align: left;
  }
  .comment-time {
    font-size: 2.8vw;
    color: #c0c4cc;
    text-align: left;
  }
}
.news-tip {
  width: 82px;
  height: 24px;
  background: #ff8831;
  border-radius: 12px;
  margin: 6px 0;
  span {
    width: 82px;
    height: 24px;
    font-size: 4vw;
    color: #ffffff;
    font-weight: bold;
  }
}
.replys-tip {
  margin: 8px 0 4px 16px;
  text-align: left;
}
.list-content {
  font-size: 3.8vw;
  color: #1c1c1c;
  text-align: left;
  // white-space: pre-wrap;
  // padding: 8px 0;
  color: #777777;
}
.custom-box {
  display: flex;
  flex-wrap: wrap;
  margin: 6px 0;
}
.custom-img {
  display: flex;
  --van-grid-item-content-padding: 0;
  flex-grow: 1;
}
.custom_detail {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.detail_left {
  display: flex;
  align-items: center;
}
.van-button--default {
  font-size: 3vw;
  color: #c0c4cc;
  background: var(--van-button-default-background-color);
  border: var(--van-button-border-width) solid
    var(--van-button-default-border-color);
}
.content-image {
  --van-grid-item-content-padding: 0;
  // display: flex;
  // justify-content: flex-start;
  // margin: 6px 0;
  // flex-wrap: wrap;
  // margin: 0px 10px 0px 0px;
}
.custom-flex {
  width: 100%;
  display: flex;
  .list-image {
    width: 108px;
    height: 72px;
    margin: 0 10px 0px 16px;
  }
}
.white {
  white-space: pre-wrap;
}
.btn-background {
  width: 100%;
  height: 60px;
  background: linear-gradient(to bottom, #c0c0c0, #292929);
  opacity: 0.8;
  position: fixed;
  bottom: 0px;
  z-index: 99;
  margin: 0px auto;
  right: 0px;
  left: 0px;
}
</style>
